<!-- #region Mobile interior navigation -->
<nav
  *ngIf="requiresNavbar"
  class="navbar navbar-light bg-light d-block d-sm-none sticky-top"
>
  <div class="container-fluid">
    <a routerLink="{{ backNavigation }}">
      <i class="bi bi-chevron-left"></i>
      {{ backTitle }}
    </a>
    <a *ngIf="showInfoButton && selectedBranch" (click)="onBranchInfo()">
      Contact Branch
      <i class="bi bi-caret-down-fill"></i>
    </a>
  </div>
</nav>
<!-- #endregion -->

<div class="container-fluid">
  <div class="row">
    <div class="col-5 col-lg-3 bg-sidebar p-0">
      <div
        class="sidebar d-none d-md-block d-flex justify-content-center w-100"
      >
        <div class="sticky-top pt-5">
          <img
            class="center-block"
            src="../../../assets/images/logo.png"
            height="125"
            alt="Eagle Finance Logo"
          />
          <h1 class="mt-5">
            Loans Made Easy.<br />
            Payments Made Affordable.<sup class="font-weight-normal">&reg;</sup>
          </h1>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-8 content">
      <!-- #region General interior navigation -->
      <div *ngIf="requiresNavbar" class="d-none d-sm-block">
        <div class="row">
          <div class="col">
            <a routerLink="{{ backNavigation }}">
              <i class="bi bi-chevron-left"></i>
              {{ backTitle }}
            </a>
          </div>
          <div *ngIf="showInfoButton" class="col align-content-end">
            <div *ngIf="selectedBranch" ngbDropdown class="text-end">
              <a class="link" id="branchInfo" ngbDropdownToggle>
                Contact Branch
              </a>
              <div
                ngbDropdownMenu
                aria-labelledby="branchInfo"
                class="bg-light py-3 px-4"
              >
                <app-branch-info></app-branch-info>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region Mobile -->
      <div class="d-sm-block d-md-none mt-2">
        <div class="d-flex justify-content-center">
          <img
            src="../../../assets/images/logo.png"
            height="100"
            alt="Eagle Finance Logo"
          />
        </div>
        <hr class="hr-style" />
      </div>
      <!-- #endregion -->

      <app-error-alert></app-error-alert>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
